module.exports = __webpack_public_path__ + "static/media/POS-Payment_jsq3l2.7c4f6f9c.jpg";